// Missing values come through as null (or the text "null").
const present = (value) => {
    const text = typeof value === "string" ? value.trim() : ""
    return text && text !== "null" ? text : null
}

// "Author (source)", or whichever of the two is present; null for neither.
const byline = (news) => {
    const author = present(news?.author)
    const source = present(news?.source)
    if (author && source) return `${author} (${source})`
    return author || source
}

export default function NewsCard({ news }) {
    const credit = byline(news)
    return (
        <div className="card h-100">
            <img
                src={`${news?.image}`}
                className="card-img-top"
                alt={`${news?.title}`}
                title={`${news?.title}`}
            />
            <div
                className="progress"
                style={{ height: "20px", borderRadius: "0px" }}
            ></div>

            <div className="card-body">
                <h5 className="card-title pb-2" title={news?.title}>
                    {news?.title.length > 100
                        ? `${news?.title.substring(0, 100)}...`
                        : news?.title}
                </h5>

                {credit && (
                    <small className="badge bg-light text-secondary">
                        <em>{`~ by: ${credit}`}</em>
                        <br></br>
                    </small>
                )}

                <p className="card-text text-start pt-3">
                    {news?.description.length > 200
                        ? `${news?.description.substring(0, 200)}...`
                        : news?.description}
                </p>

                <a href={news?.url} target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-outline-secondary btn-sm mt-3">
                        Read more
                    </button>
                </a>
            </div>

            <div className="card-footer">
                <small className="text-body-secondary">
                    <em>
                        {new Date(news?.published_at).toLocaleDateString(
                            "en-US",
                            {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                            }
                        )}
                    </em>
                </small>
            </div>
        </div>
    )
}
